/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  deleteVacationsPlan,
  getVacationsPlanList,
} from "../../../apis/vacation/vacation-plan";
import { ControlTable } from "../../../components/Table";
import VacationPlan from "./VacationPlan";
import {
  getCurrentYear,
  getYearAddOneRange,
  dateDayofWeekFormat,
  dateToFormat,
} from "../../../utils/date";
import { shallowEqual, useSelector } from "react-redux";
import { get, isEmpty } from "lodash";
import Filters from "../../../components/Filters";
import { getVacationsLeavesManager } from "../../../apis/vacation/vacation-leave-manager";
import Icon from "../../../components/Icon";
import warningIcon from "../../../assets/images/icon/warning-icon.svg";
import useForm from "../../../hooks/useForm";
import systemAlert from "../../../utils/systemAlert";

const VacationPlanList = ({
  detailOpen,
  setDetailOpen,
  permission,
  mode,
  setMode
}) => {
  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );
  const [fields] = useState([
    {
      title: "이름",
      key: "employeeIdx",
      type: 'profile'
    },
    { title: "휴가유형", key: "vacationTitle" },
    { title: "사용일수", key: "useCount" },
    {
      title: "사용기간",
      key: "range",
      onValue: (value, field, data) => {
        return `${dateDayofWeekFormat(data.startDate)} ~ ${dateDayofWeekFormat(
          data.endDate
        )}`;
      },
    },
  ]);
  const [planDate, setPlanDate] = useState({
    planStartDate: null,
    planEndDate: null,
  });
  const [detailData, setDetailData] = useState({});

  useEffect(() => {
    getVacationsLeavesManager().then((res) => {
      const { planStartDate, planEndDate } = res.data;
      setPlanDate({
        planStartDate,
        planEndDate,
      });
    });
  }, []);

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
  } = useForm(
    {
      range: {
        startDate: {
          from: `${new Date().getFullYear()}-01-01`,
          to: `${new Date().getFullYear()}-12-31`,
        },
      },
      employee: null,
      page: 0,
      limit: 999
    },
  )

  const [filterConfig, setFilterConfig] = useState([]);
  const _setFilterConfig = () => {

    const filterList = [{
      title: "연도",
      type: "select",
      key: "term",
      value: getCurrentYear(),
      options: {
        list: getYearAddOneRange(),
      },
      width: "33%",
    }]

    if (permission && permission.level > 2) {
      filterList.push({
        title: "대상자",
        type: 'searchEmployees',
        key: "employee",
        isSingle: true,
      })
    }

    setFilterConfig(filterList)
  }

  useEffect(() => {
    if (user) {
      _setFilterConfig()
      submit(form);
      setSubmit(submit)
    }
  }, [user]);

  const submit = ({ term, ...form }) => {
    if (!isEmpty(term)) {
      form.range.startDate.from = `${term}-01-01`
      form.range.startDate.to = `${term}-12-31`
    }

    let targetEmployeeIdx
    if (!isEmpty(form.employee)) {
      targetEmployeeIdx = form.employee[0].idx
    } else {
      if (!(permission && permission.level > 2)) {
        targetEmployeeIdx = get(user, "employeeIdx")
      }
    }

    delete form.employee

    setIsLoading(true);
    getVacationsPlanList({
      search: {
        employeeIdx: targetEmployeeIdx,
      },
      ...form
    })
      .then((res) => {
        setIsLoading(false);
        setList(res.data.vacations);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => setIsLoading(false));
  };

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (data) => {
          systemAlert('해당 휴가 계획을 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '승인',
                onClick: () => {
                  deleteVacationsPlan(data.planIdx, data.employeeIdx)
                    .then((res) => { submit(form) })
                    .catch((err) => { });
                }
              }
            ]
          })
        },
      },
      {
        type: "edit",
        action: (data) => {
          setDetailData(data);
          setDetailOpen(true);
          setMode('modify')
        },
      },
    ],
  };

  const handleRowClick = (data, e) => {
    const tagName = e.target.tagName
    if (!(tagName === "TR" || tagName === 'TD')) return
    setDetailData(data);
    setDetailOpen(true);
    setMode('view')
  }

  return (
    <div className="vacation-plan">
      {!isEmpty(planDate.planStartDate) && !isEmpty(planDate.planEndDate) && (
        <div className="plan-date-info-wrap">
          <div className="plan-date-info-text-wrap">
            <Icon src={warningIcon} />
            <span className="plan-date-info-text">
              {permission.level > 1 ? (
                `${dateToFormat(planDate.planStartDate, "YYYY/MM/DD")} ~${" "}
              ${dateToFormat(planDate.planEndDate, "YYYY/MM/DD")} 휴가 계획
              작성기간입니다. 기간이 지난 후 수정 불가합니다.`)
                : (
                  '작성 권한이 없습니다(조회만 가능) 회사 관리자에게 문의하세요.'
                )}
            </span>
          </div>
        </div>
      )}
      <Filters
        isLoading={isLoading}
        filters={filterConfig}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        title="휴가 계획"
        fields={fields}
        list={list}
        isLoading={isLoading}
        rowBtn={permission.level > 1 ? rowBtnConfig : {}}
        onSelect={handleRowClick}
      />
      <VacationPlan
        mode={mode}
        setMode={setMode}
        detailOpen={detailOpen}
        setDetailOpen={setDetailOpen}
        data={detailData}
        setData={setDetailData}
        listSubmit={() => submit(form)}
      />
    </div>
  );
};

export default VacationPlanList;
